export interface ProfileAttributePillProps {
  icon: React.ReactNode;
  label: string;
  variant?: "gender" | "interestedIn";
  "data-testid"?: string;
}

const variantBgClass: Record<"gender" | "interestedIn", string> = {
  gender: "bg-lavender-500",
  interestedIn: "bg-pink-500",
};

/**
 * Read-only pill showing an icon and label. Used for gender and "interested in"
 * on the profile card; can be reused elsewhere.
 */
export function ProfileAttributePill({
  icon,
  label,
  variant = "gender",
  "data-testid": dataTestId,
}: ProfileAttributePillProps) {
  return (
    <span
      className={`inline-flex items-center gap-2 rounded-button px-3 py-1.5 text-sm font-medium text-white ${variantBgClass[variant]}`}
      data-testid={dataTestId}
    >
      <span className="size-4 shrink-0" aria-hidden>
        {icon}
      </span>
      <span>{label}</span>
    </span>
  );
}
